export default __webpack_public_path__ + "static/media/man4.2e722a50.jpg";